import React from "react";

const Footer = () => {
  return (
    <div className="bg-dark text-white text-center p-4 mt-3">
      <h2>Design And Developed By : Sachinpatle</h2>
      <h6>All Rights Reserved &copy; Sachinpatle</h6>
    </div>
  );
};

export default Footer;
